<template>
<div class="move-box">
  <div class="table-right-line" :style="{ left: left - 3 + 'px' }" @mousedown="rightLineMouseDown"></div>
  <div class="move-line" ref="move-line"></div>
</div>
</template>
<script>
export default {
  props: ['left','disabled'],
  data() {
    return {
      isCanMove: false,
      screenX: 0,
      move: 0,
      dom: ''
    }
  },
  methods: {
    rightLineMouseDown(e) {
      if(this.disabled) return // 表头移动中
      this.isCanMove = true
      this.screenX = e.screenX
      this.move = e.screenX
      this.dom = e.target
      this.$refs['move-line'].style.left = e.target.offsetLeft  + 'px'
      this.$refs['move-line'].style.top = 0 + 'px'
      this.$refs['move-line'].style.height = '100%'
      this.$refs['move-line'].style.display = 'block'
      document.onmousemove = (e) => {
        e.preventDefault()
        if (this.isCanMove) {
          let val = e.screenX - this.move
          window.document.body.style.cursor = 'w-resize'
          this.$refs['move-line'].style.left = this.$refs['move-line'].offsetLeft + val + 'px'
          this.move = e.screenX
        }
      }
      document.onmouseup = (e) => {
        if (this.isCanMove) {
          document.onmousemove = null
          document.onmouseup = null
          window.document.body.style.cursor = 'auto'
          this.$refs['move-line'].style.display = 'none'
          let val = this.left + (e.screenX - this.screenX)
          val < 260 ? (val = 260) : val
          this.$emit('moveCompete', val)
          this.isCanMove = false
        }
      }
    }
  }
}
</script>
<style lang="scss">
.move-box {
  .table-right-line {
    cursor: w-resize;
    position: absolute;
    top: 0;
    z-index: 1002;
    width: 5px;
    height: 100%;
    flex-shrink: 0;
    &::after {
      content: '';
      display: block;
      width: 1px;
      height: 100%;
      margin: 0 auto;
      background-color: #e7e8ed99;
    }
  }
  .move-line {
    position: absolute;
    width: 5px;
    z-index: 1002;
    display: none;
    &::after {
      content: '';
      height: 100%;
      margin: 0 auto;
      width: 1px;
      background-color: #0d70e8;
      display: block;
      opacity: 0.4;
    }
    &::before {
      content: '';
      width: 100%;
      height: 30px;
      background-color: #d3e7ff;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
    }
  }
}
</style>
